import Repository from "./Repository"

export default {
  /**
   *Check if the give user is active or not
   *
   * @param {Object} data
   */
  isActive(data) {
    return Repository.post(`/isactive/`, data)
  },

  recordLogout() {
    return Repository.get(`/logout/`)
  },

  /**
   * Verify Email
   *
   * @param {string} type
   * @param {string} id
   */
  verifyEmail(type, id) {
    return Repository.post(`/signupverify/${type}/${id}/`)
  },
  resendEmailVerification(payload) {
    return Repository.post(`/v2/accounts/verification/create-new-link/`, payload)
  },

  getUserDetails(uid, cid, role) {
    return Repository.get(`/usercircle/?user_id=${uid}&circle_id=${cid}&role=${role}`)
  },
  editUserDetails(uid, cid, role, payload) {
    return Repository.put(`/usercircle/?user_id=${uid}&circle_id=${cid}&role=${role}`, payload)
  },

  /**
   * Get about section
   *
   * @param {Object} user
   */
  getAbout(user, circleId) {
    if (user.role === "patient") {
      return Repository.get(`/normaluserabout/?user_id=${user.id}&circle_id=${circleId}&role=${user.role}`)
    } else if (user.role === "hospital_administrator" || user.role === "hospital") {
      return Repository.get(`/hospital/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "caregiver") {
      return Repository.get(`/caregiver/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "doctor") {
      return Repository.get(`/doctor/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "advocate") {
      return Repository.get(`/advocate/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "nfp_administrator" || user.role === "nfp") {
      return Repository.get(`/nfp/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "hcp") {
      return Repository.get(`/hcp/?user_id=${user.id}&circle_id=${circleId}`)
    } else {
      return Repository.get(`/clinic/?user_id=${user.id}&circle_id=${circleId}&page=1&items=10`)
    }
  },

  getViewUserAbout(user, circleId) {
    if (user.role === "patient") {
      return Repository.get(`/normaluserabout/?user_id=${user.id}&circle_id=${circleId}&role=${user.role}`)
    } else if (user.role === "hospital_administrator") {
      return Repository.get(`/hospital/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "caregiver") {
      return Repository.get(`/caregiver/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "doctor") {
      return Repository.get(`/doctorinfo/?id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "advocate") {
      return Repository.get(`/advocate/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "nfp_administrator") {
      return Repository.get(`/nfp/?user_id=${user.id}&circle_id=${circleId}`)
    } else if (user.role === "hcp" || user.role === "ohcp") {
      return Repository.get(`hcpinfo?id=${user.id}&circle_id=${circleId}`)
    } else {
      return Repository.get(`/clinic/?user_id=${user.id}&circle_id=${circleId}&page=1&items=10`)
    }
  },

  getNfpAbout(user, circleId) {
    return Repository.get(`/nfpinfo/?id=${user.id}&circle_id=${circleId}`)
  },

  getDoctorsSearch: payload => {
    const { circleId, items, user, location, age, gender, speciality } = payload
    const u = user ? `&username=${user}` : ""
    const l = location ? `&location=${location}` : ""
    const a = age ? `&age=${age}` : ""
    const g = gender ? `&gender=${gender}` : ""
    const s = speciality ? `&speciality=${speciality}` : ""
    return Repository.get(`/doctorsearch/?page_num=1&items=${items}&circle_id=${circleId}` + u + l + a + g + s)
  },

  /**
   * Close Account
   * @param Integer id
   */
  closeAccount(circleId) {
    return Repository.delete(`useraccountclose/?circle_id=${circleId}`)
  },

  /**
   * Get Self Circle Members
   * @param Integer userId
   * @param Integer circleId
   * @param Integer page
   * @param Integer limit
   *
   * removed EXT_REF_ID
   */
  getSelfCircleMembers(currentuser, circleId, page, limit) {
    return Repository.get(`/profilecirclepeople/?page_num=${page}&items=${limit}&${`user_id=${currentuser.id}`}&circle_id=${circleId}&role=${currentuser.role}`)
  },

  /**
   * Get Other Circle Members
   * @param Integer userId
   * @param Integer circleId
   * @param Integer page
   * @param Integer limit
   */
  getOtherCircleMembers(user, circleId, page, limit, filter_role) {
    let id = `&user_id=${user.id}`
    let c = filter_role ? `&filter_role=${filter_role}` : ``
    return Repository.get(`/profilecirclesubcircles/?page_num=${page}&items=${limit}` + id + `&circle_id=${circleId}&role=${user.role}` + c)
  },

  getOtherCircleMembersCount(user, circleId, page, limit, filter_role) {
    let id = `&user_id=${user.id}`
    let c = filter_role ? `&filter_role=${filter_role}` : ``
    return Repository.get(`/profilecirclesubcirclescount/?page_num=${page}&items=${limit}` + id + `&circle_id=${circleId}&role=${user.role}` + c)
  },

  /**
   * Get Circle Providers
   * @param Integer userId
   * @param Integer circleId
   * @param Integer page
   * @param Integer limit
   *
   * removed ext_ref_id
   */
  getCircleProviders(user, circleId, page, limit) {
    return Repository.get(`/profilecircledoctors/?page_num=${page}&items=${limit}&${`user_id=${user.id}`}&circle_id=${circleId}&role=${user.role}`)
  },

  getCircleMembersCount(user, circleId, page, limit) {
    return Repository.get(`/profilecircledoctorscount/?page_num=${page}&items=${limit}&${`user_id=${user.id}`}&circle_id=${circleId}&role=${user.role}`)
  },

  getAllCircleMembers(user, circleId, page, limit) {
    return Repository.get(`/allprofilecircledoctors/?page_num=${page}&items=${limit}&${`user_id=${user.id}`}&circle_id=${circleId}&role=${user.role}`)
  },

  /**
   * Add User to Circle
   * @param Integer userId
   */
  addToCircle(user, circleId) {
    // console.log(user, "IN USER REPO");
    return Repository.post(`/addtocircle/?${user.ext_ref_id ? `ext_ref_id=${user.ext_ref_id}` : `user_id=${user.id}`}&circle_id=${circleId}&role=${user.role === "hcp" ? "other" : user.role}`)
  },

  addUserByTypeToCircle(extRefId, circleId, type) {
    // console.log(type, extRefId, circleId);
    switch (type) {
      case "physician":
        return Repository.post(`/addtocircle/?ext_ref_id=${extRefId}&circle_id=${circleId}&role=${type}`)
      case "doctor":
        return Repository.post(`/addtocircle/?${extRefId.ext_ref_id ? `ext_ref_id=${extRefId.ext_ref_id}` : `user_id=${extRefId.id}`}&circle_id=${circleId}&role=${type}`)

      case "hospital_administrator":
        return Repository.post(`/addhospital/?${extRefId.ext_ref_id ? `ext_ref_id=${extRefId.ext_ref_id}` : `user_id=${extRefId.id}`}&circle_id=${circleId}&role=${type}`)
      case "hospital":
        return Repository.post(`/addhospital/?ext_ref_id=${extRefId}&circle_id=${circleId}&role=${type}`)
      case "clinic_administrator":
        return Repository.post(`/addclinic/?${extRefId.ext_ref_id ? `ext_ref_id=${extRefId.ext_ref_id}` : `user_id=${extRefId.id}`}&circle_id=${circleId}&role=${type}`)
      case "clinic":
        return Repository.post(`/addclinic/?ext_ref_id=${extRefId}&circle_id=${circleId}&role=${type}`)
      case "other":
        return Repository.post(`/addhcp/?ext_ref_id=${extRefId}&circle_id=${circleId}&role=${type}`)
      case "hcp":
        return Repository.post(`/addhcp/?ext_ref_id=${extRefId}&circle_id=${circleId}&role=${type}`)
      case "nfp_administrator":
        return Repository.post(`addnfp/?${extRefId.ext_ref_id ? `ext_ref_id=${extRefId.ext_ref_id}` : `user_id=${extRefId.id}`}&circle_id=${circleId}`)
      case "nfp":
        return Repository.post(`addnfp/?ext_ref_id=${extRefId}&circle_id=${circleId}`)
      default:
        return Promise.reject({
          response: { data: { message: "Failed to add to circle" } },
        })
    }
  },

  addVirtualDocToCircle(user, circleId, type) {
    return Repository.post(`/${type}/?ext_ref_id=${user.id}&circle_id=${circleId}&role=${type}`)
  },

  /**
   * Request to Add
   * @param Integer userId
   * @param Integer circleId
   */
  requestToAdd(user, circleId) {
    return Repository.post(`/requesttoadd/?user_id=${user.id}&circle_id=${circleId}&role=${user.role}`)
  },

  /**
   * Remove user from his/her circle
   * @param Integer userId
   */
  removeFromCircle(user, circleId) {
    return Repository.delete(`/removefromcircle/?user_id=${user.id}&circle_id=${circleId}`)
    // {{url}}/api/removefromcircle/?user_id=4
  },

  /**
   * Recommend a Doctor
   * @param Integer userId
   * @param Integer circleId
   */
  recommendDoctor(payload) {
    return Repository.post(`/doctorrecommend/`, payload)
  },

  /**
   * Recommend a physician by a physician
   */

  recommendPhysician(payload) {
    return Repository.post(`/reviews/`, payload)
  },

  SaveToDirectory(payload) {
    return Repository.post(`/saveprofile/`, payload)
  },

  /**
   * Recommend a Doctor
   * @param object payload
   * @param string type
   */
  reviewEntityBasedOnType(payload, type) {
    // console.log(payload, type, "in user");
    return Repository.post(`/reviews/`, payload)
    // switch (type) {
    //   case "doctor":
    //   // return Repository.post(`/doctorrecommend/`, payload);
    //   case "physician":
    //   // return Repository.post(`/doctorrecommend/`, payload);
    //   case "hospital":
    //   // return Repository.post(`/hospitalreview/`, payload);
    //   case "clinic":
    //   // return Repository.post(`/clinicreview/`, payload);
    //   case "other":
    //   // return Repository.post(`/hcpreview/`, payload);
    //   case "hcp":
    //   // return Repository.post(`/hcpreview/`, payload);
    //   case "nfp":
    //     // return Repository.post(`/nfpreview/`, payload);
    //     return Repository.post(`/reviews/`, payload);
    //   default:
    //     return Promise.reject({
    //       response: { data: { message: "Failed to submit a review" } },
    //     });
    // }
  },

  /**
   * Get Post Updates
   * @param Integer page
   * @param Integer limit
   * @param Integer userId
   */
  getUpdates(page, limit, user, circleId) {
    return Repository.get(
      `dovemedpost/?circle_id=${circleId}&page_num=${page}&items=${limit}&sort_by=-created_at&${user.ext_ref_id ? `ext_ref_id=${user.ext_ref_id}` : `user_id=${user.id}`}&receiver_user=${
        user.id
      }&role=${user.role}`
    )
  },

  getProfileReviews(pagenum, items, circleid, reviewerid, role, sort) {
    return Repository.get(
      `reviews/?page_num=${pagenum}&items=${items}&circle_id=${circleid}&reviewer_id=${reviewerid}&reviewer_role=${role}&reviewee_role=${sort}&recommended=False`
      // `allreviews/?page_num=${pagenum}&items=${items}&circle_id=${circleid}&reviewer_id=${reviewerid}&reviewer_role=${role}&reviewee_role=${sort}&recommended=False`
    )
  },

  getMedReviews(circleId, pagenum, items, reviewerid, role) {
    return Repository.get(
      // `polls/?circle_id=${circleId}&page_num=${page}&items=${limit}&user=${user_id}`
      // medicationreview/?page_num=1&items=10&reviewer_id=6&recommend=False
      `medicationreview/?circle_id=${circleId}&page_num=${pagenum}&items=${items}&reviewer_id=${reviewerid}&reviewer_role=${role}&recommend=False`
    )
  },

  getTreatmentRecommend(circleId, pagenum, items, reviewerid, role, sort) {
    return Repository.get(
      // `polls/?circle_id=${circleId}&page_num=${page}&items=${limit}&user=${user_id}`
      // medicationreview/?page_num=1&items=10&reviewer_id=6&recommend=False
      `medicationreview/?circle_id=${circleId}&page_num=${pagenum}&items=${items}&reviewer_id=${reviewerid}&reviewer_role=${role}&medication_type=${sort}&recommend=True`
    )
  },

  getProfileRecommend(pagenum, items, reviewerid, role, circle_id, sort) {
    return Repository.get(
      // `polls/?circle_id=${circleId}&page_num=${page}&items=${limit}&user=${user_id}`
      // medicationreview/?page_num=1&items=10&reviewer_id=6&recommend=False
      // reviews/?page_num=1&items=10&reviewer_id=&circle_id=&reviewer_role=
      `reviews/?page_num=${pagenum}&items=${items}&reviewer_id=${reviewerid}&circle_id=${circle_id}&reviewer_role=${role}&reviewee_role=${sort}&recommended=True`
    )
  },

  /**
   * Get Post Updates
   * @param Integer page
   * @param Integer limit
   * @param Integer userId
   */
  getUpdatesHospital(page, limit, user, circleId) {
    return Repository.get(`dovemedpost/?circle_id=${circleId}&page_num=${page}&items=${limit}&sort_by=-created_at&ext_ref_id=${user.id}&role=${user.role}`)
  },

  /**
   * Get Post Updates
   * @param Integer page
   * @param Integer limit
   * @param Integer userId
   */
  getUpdatesWithReceiver(page, limit, user, circleId) {
    return Repository.get(`dovemedpost/?circle_id=${circleId}&page_num=${page}&items=${limit}&sort_by=-created_at&user_id=${user.id}&receiver_user=${circleId}&role=${user.role}`)
  },

  getPollsByUser(page, limit, user_id, circleId, role) {
    return Repository.get(`polls/?circle_id=${circleId}&page_num=${page}&items=${limit}&user=${user_id}&user_role=${role}`)
  },

  getMutedUsers(circleId) {
    return Repository.get(`muteuser/?circle_id=${circleId}`)
  },

  /**
   * Get Favorites
   * @param Integer page
   * @param Integer limit
   */
  getFavorites(page, limit, circleId, user) {
    return Repository.get(`/reactionsfavoritelist/?${user.ext_ref_id ? `ext_ref_id=${user.ext_ref_id}` : `user_id=${user.id}`}&page_num=${page}&items=${limit}&circle_id=${circleId}&role=${user.role}`)
  },

  getFavoritesPost(page, limit, circleId, user) {
    return Repository.get(`/reactionsfavoritelist/?${`user=${user.id}`}&page_num=${page}&reacted_on_type=1&items=${limit}&circle_id=${circleId}&role=${user.role}`)
  },
  getFavoritesPolls(page, limit, circleId, user) {
    return Repository.get(`/reactionsfavoritelist/?${`user=${user.id}`}&page_num=${page}&reacted_on_type=5&items=${limit}&circle_id=${circleId}&role=${user.role}`)
  },

  getFavoritesJobs(page, limit, circleId, user) {
    return Repository.get(`/reactionsfavoritelist/?${`user=${user.id}`}&page_num=${page}&reacted_on_type=12&items=${limit}&circle_id=${circleId}&role=${user.role}`)
  },

  getFavoritesEvents(page, limit, circleId, user) {
    return Repository.get(`/reactionsfavoritelist/?${`user=${user.id}`}&page_num=${page}&reacted_on_type=13&items=${limit}&circle_id=${circleId}&role=${user.role}`)
  },

  getFavoritesPressReleases(page, limit, circleId, user) {
    return Repository.get(`/reactionsfavoritelist/?${`user=${user.id}`}&page_num=${page}&reacted_on_type=14&items=${limit}&circle_id=${circleId}&role=${user.role}`)
  },

  // 5 - poll

  getFavoritesQA(page, limit, circleId, user) {
    return Repository.get(`/reactionsfavoritelist/?${`user=${user.id}`}&page_num=${page}&reacted_on_type=3&items=${limit}&circle_id=${circleId}&role=${user.role}`)
  },

  getRecommendedUsers(circleid, page, limit, sort, role, search) {
    let c = search ? `&search=${search}` : ``
    let r = role ? `&reviewee_role=${role}` : ``
    return Repository.get(`/recommend/?${`circle_id=${circleid}`}&page_num=${page}&items=${limit}&sort=${sort}` + c + r)
  },

  getIndividualRecommend(circle_id, page = 1, items = 10, reviewee_id, type) {
    const t = type ? `&sort=${type}` : ""
    return Repository.get(`/recommend/?page_num=${page}&items=${items}&circle_id=${circle_id}&reviewee_id=${reviewee_id}` + t)
  },

  /**
   * Get other favorites
   *
   * @param {*} page
   * @param {*} limit
   * @param {*} userId
   * @param {*} circleId
   */
  getOtherFavorites(page, limit, user, circleId) {
    return Repository.get(`/otheruserfavoritelist/?page_num=${page}&items=${limit}&circle_id=${circleId}&user_id=${user.id}`)
  },

  /**
   * Get Treatments
   * @param Integer userId
   */
  getTreatments(user, circleId, type = null, page, items) {
    const tType = type ? `&treatment_type=${type}` : ""
    const pagination = page ? `&page_num=${page}&items=${items}` : ""
    return Repository.get(`/treatment/?user_id=${user.id}&circle_id=${circleId}&role=${user.role}` + tType + pagination)
  },

  /**
   * Delete treatment
   * @param Object payload
   * @param Integer treatmentId
   */
  removeTreatment(treatmentId) {
    return Repository.delete(`/treatment/?ids=${treatmentId}`)
  },

  /**
   * Get Notification Settings
   * @param Integer circleId
   */
  getNotificationSettings(circleId) {
    return Repository.get(`/notificationsettings/?circle_id=${circleId}`)
  },

  /**
   * Change Notification Settings
   * @param Object payload
   * @param Integer circleId
   */
  changeNotificationSettings(payload, circleId) {
    return Repository.put(`/notificationsettings/?circle_id=${circleId}`, payload)
  },

  /**
   * Update Profile picture
   * @param Object payload
   */
  updateProfilePic(payload, user, circleId) {
    return Repository.put(`/user/?id=${user.id}&circle_id=${circleId}`, payload)
  },

  /**
   * Get Presigned URL
   * @param Object payload
   */
  getPresignedUrl(payload) {
    return Repository.post(`/imageurl/`, payload)
  },

  /**
   * Update Advocate Contact details
   * @param Integer userId
   * @param Object payload
   * @param Integer locationId
   */
  updateAdvocateOrganisationContact(user, locationId, payload) {
    return Repository.put(`/advocatecontactdetails/?user_id=${user.id}&location_id=${locationId}`, payload)
  },

  /**
   * Update Advocate
   * @param Integer userId
   * @param Object payload
   */
  updateAdvocateDetails(user, payload) {
    return Repository.put(`/advocate/?user_id=${user.id}`, payload)
  },

  /**
   * Get Other user profile
   * @param Integer userId
   */
  getOtherUserProfile(user, circleId) {
    return Repository.get(`/otheruserprofile/?${user.ext_ref_id ? `ext_ref_id=${user.ext_ref_id}` : `user_id=${user.id}`}&circle_id=${circleId}&role=${user.role}`)
  },
  getOtherUserProfileWithId(user, circleId) {
    return Repository.get(`/otheruserprofile/?user_id=${user.id}&circle_id=${circleId}&role=${user.role}`)
  },

  getCircleStats(id, circleId) {
    return Repository.get(`usercirclestats/?user_id=${id}&circle_id=${circleId}`)
    // return Repository.get(`userprofile/?user_id=${id}&circle_id=${circleId}`)
  },

  /**
   * Get Other Entity profile
   * @param Integer userId
   */
  getOtherEntityProfile(user, circleId) {
    let role = null
    if (user.role === "hospital_administrator") {
      role = "hospital"
    } else if (user.role === "clinic_administrator") {
      role = "clinic"
    } else if (user.role === "nfp_administrator") {
      role = "nfp"
    } else {
      role = user.role
    }
    return Repository.get(`/${role}info/?id=${user.ext_ref_id ? user.ext_ref_id : user.id}${circleId ? `&circle_id=${circleId}` : ""}`)
  },

  /**
   * Get Self Profile
   * @param {*} userId
   */
  getSelfProfile(user, circleId) {
    // console.log("-- getSelfProfile called --")
    return Repository.get(`/userprofile/?user_id=${user.id}&circle_id=${circleId}`)
  },

  /**
   * Get symptoms
   *
   * @param {integer} userId
   * @param {integer} circleId
   */
  getSymptoms(user, circleId) {
    return Repository.get(`${user.role === "patient" ? "symptoms" : "caregiversymptoms"}/?user_id=${user.id}&circle_id=${circleId}`)
  },

  /**
   * Get symptoms
   *
   * @param {integer} userId
   * @param {integer} circleId
   */
  getActivity(circleId) {
    return Repository.get(`activity/?circle_id=${circleId}`)
  },

  /**
   * Get symptoms
   *
   * @param {id} userId
   * @param {integer} items
   * @param {integer} pageno
   */

  getUserReviews(pageno, items, circle_id, id) {
    return Repository.get(`reviews/?page_num=${pageno}&items=${items}&circle_id=${circle_id}&reviewer_id=${id}`)
  },
  /**
   * Add Provider
   *
   * @param {JSON} data
   */
  addProvider(data) {
    return Repository.post(`provider/`, data)
  },

  /**
   * Get Treatment Reviews with pagination
   *
   * @param {Object} medicine
   */
  getTreatmentReviews(cid, pageNum, limit, id, type) {
    return Repository.get(`/medicationreview/?circle_id=${cid}&page_num=${pageNum}&items=${limit}&medication_id=${id}&medication_type=${type || "nonmedicaltreatments"}`)
  },

  /**
   * Review Medication / Treatment
   *
   * @param {Object} payload
   */
  reviewMedication(payload) {
    return Repository.post("medicationreview/", payload)
  },

  updateDovedaily(cid, payload) {
    return Repository.put("/dovedaily/?circle_id=" + cid, payload)
  },

  getDovedaily(cid) {
    return Repository.get("/dovedaily/?circle_id=" + cid)
  },

  /**
   * Get Owner Profile Dovedaily
   */
  getProfDovedaily(cid, s_date = null, e_date = null, year = null) {
    const params = year ? `&year=${year}` : `&from_date=${s_date}&to_date=${e_date}`
    return Repository.get(`/dovedaily/?circle_id=${cid}${params}`)
    // return Repository.get(`/dovedaily/?circle_id=${cid}&from_date=${s_date}&to_date=${e_date}`)
  },

  /**
   * Get Others Profile Dovedaily
   */
  getOthersProfDovedaily(cid, uid, year, month) {
    return Repository.get(`/otherprofiledovedaily/?circle_id=${cid}&year=${year}&month=${month}&user_id=${uid}`)
  },

  /**
   * add Treatments
   * @param Integer userId
   */
  addTreatments(payload) {
    return Repository.post(`/treatment/`, payload)
  },

  /**
   * Edit Treatments
   * @param Integer userId
   */
  editTreatments(id, payload) {
    return Repository.put(`/treatment/?id=${id}`, payload)
  },

  getWelcomePostImage(page, item, circleId) {
    return Repository.get(`/dovemedpostlist/?page_num=${page}&items=${item}&sort_by=-created_at&is_deleted=False&is_welcome=True&circle_id=${circleId}`)
  },

  muteUser(payload) {
    return Repository.put(`/muteuser/`, payload)
  },

  UnmuteUser(payload) {
    return Repository.put(`/muteuser/`, payload)
  },

  getMyDoveDirectory(page_num, items, circle_id, owner_user, owner_role, filter_role) {
    let s = filter_role ? `&saved_user_role=${filter_role}` : ""
    return Repository.get(`/saveprofile/?page_num=${page_num}&items=${items}&circle_id=${circle_id}&owner_user=${owner_user}&owner_user_role=${owner_role}` + s)
  },

  suggestCircle(payload) {
    return Repository.post(`/circlesuggest/`, payload)
  },

  getMyRecentlyJoinedCircles(cid) {
    return Repository.get(`/recentlyjoinedcircle/?circle_id=${cid}&page_num=1&items=3`)
  },

  getOtherConditions(u_id, c_id, role) {
    return Repository.get(`/userothercondition/?user_id=${u_id}&circle_id=${c_id}&user_role=${role}`)
  },

  saveOtherConditions(payload) {
    return Repository.post(`/userothercondition/`, payload)
  },

  deleteOtherConditions(id) {
    return Repository.delete(`/userothercondition/?id=${id}`)
  },

  saveOtherConditionSymptoms(payload) {
    return Repository.post(`/usersymptom/`, payload)
  },

  // editOtherConditionSymptoms(payload) {
  //   return Repository.post(`/usersymptom/`, payload)
  // },

  saveOtherConditionMedication(payload) {
    return Repository.post(`/usermedication/`, payload)
  },

  editOtherConditionMedication(id, payload) {
    return Repository.put(`/usermedication/?id=${id}`, payload)
  },

  deleteOtherConditionMedication(id) {
    return Repository.delete(`/usermedication/?id=${id}`)
  },

  saveOtherConditionActivity(payload) {
    return Repository.post(`/useractivity/`, payload)
  },

  editOtherConditionActivity(id, payload) {
    return Repository.put(`/useractivity/?id=${id}`, payload)
  },

  deleteOtherConditionActivity(id) {
    return Repository.delete(`/useractivity/?id=${id}`)
  },

  saveOtherConditionComplimentary(payload) {
    return Repository.post(`/usercomplimentary/`, payload)
  },

  editOtherConditionComplimentary(id, payload) {
    return Repository.put(`/usercomplimentary/?id=${id}`, payload)
  },

  deleteOtherConditionComplimentary(id) {
    return Repository.delete(`/usercomplimentary/?id=${id}`)
  },

  saveOtherConditionNutrition(payload) {
    return Repository.post(`/usernutrition/`, payload)
  },

  editOtherConditionNutrition(id, payload) {
    return Repository.put(`/usernutrition/?id=${id}`, payload)
  },

  deleteOtherConditionNutrition(id) {
    return Repository.delete(`/usernutrition/?id=${id}`)
  },

  saveOtherConditionProcedure(payload) {
    return Repository.post(`/userprocedure/`, payload)
  },

  editOtherConditionProcedure(id, payload) {
    return Repository.put(`/userprocedure/?id=${id}`, payload)
  },

  deleteOtherConditionProcedure(id) {
    return Repository.delete(`/userprocedure/?id=${id}`)
  },
}



// WEBPACK FOOTER //
// ./src/repositories/userRepository.js